// Estado de cotizacion

import { Chip } from '@mui/material';

export function getQuatationStatusConfig() {
  return {
    NEW: { label: 'Nueva', color: 'primary' },
    PENDING: { label: 'Pendiente', color: 'warning' },
    APPROVED: { label: 'Aprobada', color: 'success' },
    REJECTED: { label: 'Rechazada', color: 'error' },
  };
}

export function getQuatationStatusDisplayName(type) {
  const config = getQuatationStatusConfig();
  return config[type]?.label || config.NEW.label;
}

export function getQuatationStatusChip(status) {
  const config = getQuatationStatusConfig();
  const current = config[status] || config.NEW;
  return <Chip
    label={current.label} 
    color={current.color} 
    size="small"
    sx={{
    borderRadius: 0
  }} />;
}

export function getQuotationStatusOptions() {
  const config = getQuatationStatusConfig();

  return Object.entries(config).map(([value, data]) => ({
    value,
    label: data.label
  }));
}